module.exports = {
      id: "adventure-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#adventure",
      toString: function () {
        return this.url;
      }
    }